/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();

import { useCallback } from 'react'

import { trackEvent } from '@/lib/analytics/google'
import { BasketItemWithProductInformation, LineItemPrice } from '@/store/basket'

/**
 * Provides a callback to track when items are removed from the shopping basket.
 * Sends remove_from_cart event to Google Analytics with item details and pricing.
 */
const useTrackRemoveFromCart = () => {
  return useCallback((item: BasketItemWithProductInformation, priceInfo: LineItemPrice | null) => {
    if (!priceInfo) return

    trackEvent('remove_from_cart', {
      currency: priceInfo.currency,
      value: priceInfo.lineTotal,
      items: [
        {
          item_id: item.productId,
          item_name: item.details?.name ?? item.productId,
          quantity: item.quantity,
          price: priceInfo.unitPrice,
          item_variant: item.variantId,
        },
      ],
    })
  }, [])
}

export { useTrackRemoveFromCart }
